import React from 'react';

// eslint-disable-next-line @loomhq/loom/no-consecutive-uppercase-letters-for-acronyms
export const SvgAddAPhoto = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 9.5c-.55 0-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1zm6.402 3.5a3 3 0 115.196 3 3 3 0 01-5.196-3zM21.5 6.5h-3.17l-1.24-1.35a1.99 1.99 0 00-1.47-.65h-6.4c.17.3.28.63.28 1 0 1.1-.9 2-2 2h-1v1c0 1.1-.9 2-2 2-.37 0-.7-.11-1-.28V20.5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2zm-13 8c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5z"
      fill="currentColor"
    />
  </svg>
);
